import { restApiRequest, getErrorMessage } from './ajax'
import * as types from '../mutation-types'

const campainDeliveryStatus = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * クリエイティブ設定キャンペーンの一覧を取得する
     * @param {*} params
     */
    getCampaignList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const agencyId = params.agencyId
        const advertiserId = params.advertiserId
        const deliveryStatus = params.deliveryStatus
        restApiRequest(
          baseURL,
          `/api/campaign/landing/counts/${params.privateCode}/${agencyId}/${advertiserId}/${deliveryStatus}`,
          params.jwtToken,
          params
        )
          .then(result => {
            if (result.status === 200) {
              var res = parse(result)
              resolve(res)
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_SETCAMPAIGNIDS, undefined)
    }
  }
}
function parse(response) {
  return response.data
}
export default campainDeliveryStatus
